<template>
  <el-form-item v-msg="{showMsg}" :class="['tender-form-label', `error-level-${errorLevel}`]" 
    :prop="prop"
    :rules="rules"
    :name="prop"
  >
    <slot></slot>
  </el-form-item>
</template>
<script>
export default {
  name: 'TenderFormLabel',
  props: {
    label: String,
    prop: String,
    hideLabel: Boolean,
    showMsg: Boolean,
    errorLevel: {
      type: Number,
      default: 0
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    labelWidth() {
      return this.label === undefined ? '0' : ''
    }
  }
}
</script>
<style lang="scss">
.tender-form-label.el-form-item--default, 
.tender-form-label.el-form-item {
  position: relative;
  .wp100 {
    width: 100%;
  }
  .el-form-item__label {
    line-height: 18px;
  }
  .el-form-item, .el-form-item__content {
    display: inline;
    font-size: inherit;
  }
  .el-form-item, .el-form-item__error {
    font-size: inherit
  }
  .el-input-group__append,
  .el-input-group__prepend {
    color: white;
    background-color: #20A0FF;
    border: 1px solid #20A0FF;
  }
}
</style>